import {AfterViewInit, Component, OnInit} from '@angular/core';
import {LayoutService} from "../../../shared/services/layout/layout.service";
import {Subscription} from "rxjs/Subscription";
import {LanguageService} from "../../../shared/services/language/language.service";

declare const $: any;

@Component({
    selector: 'app-city-touch',
    templateUrl: './city-touch.component.html',
    styleUrls: ['./city-touch.component.scss']
})
export class CityTouchComponent implements OnInit, AfterViewInit {

    private languageSubscripton: Subscription;
    public currentLanguage = 'en';

    constructor(private layoutService: LayoutService,
                private languageService: LanguageService) {
        this.layoutService.setTitle('City Touch | Smart Lighting System');
    }

    ngOnInit() {
        this.subscribeLanguageEvents();

    }

    ngAfterViewInit(): void {
        setTimeout(() => {

            $('#ctVid').get(0).play();
        }, 500);
    }

    ngOnDestroy(): void {
        this.unsubscribeLanguageEvents();

    }

    private subscribeLanguageEvents() {
        this.languageSubscripton = this.languageService.language.subscribe((val) => {
            this.currentLanguage = val;
        });
    }

    private unsubscribeLanguageEvents() {
        this.languageSubscripton.unsubscribe();
    }


    scrollToDetails = () => {
        $("html, body").stop().animate({scrollTop: $('#cityTouchDetails').offset().top}, 500, 'swing');
    };


}



// WEBPACK FOOTER //
// /var/www/luvi/frontend/src/app/components/public/city-touch/city-touch.component.ts